import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { PSA_DETAIL_ENDPOINT, PSA_INDICE_ENDPOINT, PSA_INDICE_PROVA_ENDPOINT, PSA_QUERY_SERVICE_INSTANCE } from './psa.config';
import { PSA_ENDPOINT } from './psa.config';
import { Psa } from './psa.model';
import {IndicePsa} from '../../core/models/indice-psa.model'
import { IPageEvent } from 'src/app/core/models/paginator.model';
import { Operazioni } from 'src/app/core/models/operazioni.model';

@Injectable({
  providedIn: 'root'
})
export class PsaService extends CrudService<Psa> {

  constructor(
    @Inject(PSA_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<Psa>,
    public readonly apiService:ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
 
    super(PSA_ENDPOINT, apiService, snackbar);
  }

  getAll<Psa>(parameter : IPageEvent, searchData?:Operazioni[]){return this.apiService.post(PSA_ENDPOINT+"?page="+parameter.pageIndex+"&size="+parameter.pageSize, searchData)}

  getDetail<Psa>(parameter : string){return this.apiService.get(PSA_DETAIL_ENDPOINT+"?id="+parameter)}

  savePsa<Psa>(data : any){return this.apiService.post(PSA_DETAIL_ENDPOINT, data)}

  //getIndicePsa<IndicePsa>(){return this.apiService.post(PSA_INDICE_ENDPOINT, [])}

  getIndicePsa<IndicePsa>(id:string){return this.apiService.get(PSA_INDICE_PROVA_ENDPOINT+"?idPsa="+id)}
}
